
export class EmptyGuid {
    public static value: string = "00000000-0000-0000-0000-000000000000";
}
